























































import { Component, Vue, Prop } from "vue-property-decorator";
import { menu } from "@/config/host.config";

import StandartDraggableAlert from "@/components/app/shared/alerts/standart-draggable-alert.vue";
import draggable from "vuedraggable";

import ComplexMenuCard from "@/components/menu/complex/complex-menu-card.vue";
import ComplexMenuEditModal from "@/components/menu/complex/complex-menu-edit-modal.vue";
import ComplexMenuListEditModal from "@/components/menu/complex/complex-menu-list-edit-modal.vue";

import type { ComplexMenuSheet } from "@/@types/menu/complex-menu";

@Component({
  components: {
    ComplexMenuCard,
    ComplexMenuEditModal,
    draggable,
    StAlert: StandartDraggableAlert,
    ComplexMenuListEditModal,
  },
})
class ComplexMenu extends Vue {
  @Prop({ type: String, default: "" }) foo!: string;
  enabled = true;
  dragging = false;
  folders = { background: "menu/complex/background" };

  private deleted = false;
  complex_menu: ComplexMenuSheet[] = [];
  active_id = "";
  edit_item: ComplexMenuSheet | null = null;

  get complex_menu_item(): ComplexMenuSheet | null {
    const item = this.complex_menu.find((el) => el._id === this.active_id);
    return item ? item : null;
  }

  mounted(): void {
    this.getComplexMenu();
  }

  openAdd(): void {
    this.edit_item = null;
    this.$nextTick(() => this.$bvModal.show("complex-menu-edit"));
  }

  mustEditCard(id: string): void {
    const item = this.complex_menu.find((el) => el._id === id);
    this.edit_item = item ? item : null;
    this.$nextTick(() => this.$bvModal.show("complex-menu-edit"));
  }

  mustEdit(id: string): void {
    this.active_id = id;
    this.$nextTick(() => this.$bvModal.show("complex-menu-list-edit"));
  }

  async saveSheet(data: Partial<ComplexMenuSheet>): Promise<void> {
    if (!data) return;
    try {
      if (this.edit_item && this.edit_item._id) {
        await this.updateComplexMenuSheetById(this.edit_item._id, data);
      } else {
        const res = await this.$axios.post(menu.complex_menu, data);
        if (res.status === 200) this.getComplexMenu();
      }
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.200")),
      });
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async confirmDeleteSheet(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("complex-menu.confirm.delete")),
        {
          title: String(this.$i18n.t("main.confirms.delete")),
          okVariant: "danger",
        }
      );
      if (result === true) await this.deleteComplexMenuSheet(id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async deleteComplexMenuSheet(id: string): Promise<void> {
    if (!id) return;
    try {
      const res = await this.$axios.delete(menu.complex_menu + "/" + id);
      if (res.status === 200) {
        const i = this.complex_menu.findIndex((el) => el._id === id);
        if (i >= 0) this.complex_menu.splice(i, 1);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async getComplexMenu(): Promise<void> {
    const params = { "match[deleted][value]": this.deleted };

    const res = await this.$axios.get(menu.complex_menu, { params });
    try {
      if (res.status === 200) {
        this.complex_menu = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async updateComplexMenuSheetById(
    id: string,
    data: Partial<ComplexMenuSheet>
  ): Promise<void> {
    if (!id) return;
    const uri = menu.complex_menu + "/" + id;
    try {
      const putres = await this.$axios.put(uri, data);
      if (putres.status === 200) {
        const i = this.complex_menu.findIndex((el) => el._id === id);
        if (i < 0) this.getComplexMenu();
        else this.$set(this.complex_menu, i, putres.data);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
export default ComplexMenu;
